/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Image, Link, UpdateNote } from '@ta-interaktiv/contentbricks'
import Tab from '../tab'
import TabMobile from '../tabMobile'
import Overlay from '../overlay'
import { chapters } from './chapters'
import { browserCheck } from '@ta-interaktiv/browsercheck'

// TODO Set the correct article ID here
const ARTICLE_ID = '813668733672'

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: null,
      width: window.innerWidth
    }
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange)
  }

  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange)
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth })
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    if (index === this.state.activeIndex) {
      this.setState({ activeIndex: null })
      window.document.body.style.overflowY = 'auto'
      window.document.body.classList.remove('freeze')
    } else {
      this.setState({
        activeIndex: index
      })
      window.document.body.style.overflowY = 'hidden'
      window.document.body.classList.add('freeze')
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toggle tab: ' + titleProps.index
    })
  }

  render() {
    return (
      <>
        {console.log('test', this.state.activeIndex)}
        <Overlay
          handleClick={this.handleClick}
          activeIndex={this.state.activeIndex}
          width={this.state.width}
        />
        <div
          className='index'
          style={
            this.state.activeIndex
              ? { overflow: 'hidden' }
              : { overflow: 'auto' }
          }
        >
          <Masthead articleId={ARTICLE_ID} inverted />
          <ThemeSwitch />

          <header className='ui vertical very fitted segment'>
            <div className='ui container headerContainer'>
              <div className='ui header title'>
                <h1>Die Russland-Schweiz-Connection</h1>
                <h2>
                  Zwischen Genf, Zug und Lugano: Wie und wo reiche Russen unser
                  Land prägen. Spurensuche in sieben Kapiteln.
                </h2>
              </div>
            </div>
            <div className='headerImageWrapperMain'>
              <div className='headerImage' />
              <div className='gradient' />
            </div>
          </header>
          {/* <div className='ui vertical inverted segment'>
          <div className='blood'></div>
        </div> */}

          <div className='ui vertical inverted segment blue'>
            <div className='ui text container'>
              <div className='ta metainfo'>
                <div className='ta author'>
                  S.&nbsp;Besson, C.&nbsp;Brönnimann, J.&nbsp;Brouzos,
                  Y.&nbsp;Cherix, M.&nbsp;Häfliger, E.&nbsp;Hess,
                  T.&nbsp;Knellwolf, B.&nbsp;Reye, Q.&nbsp;Schlapbach,
                  O.&nbsp;Zihlmann, C.&nbsp;Zürcher
                </div>
                <div className='ta updated'>Aktualisiert am 18. März 2022</div>
              </div>
              <div className='ta text'>
                <p>
                  Das Thema «Oligarchen» führt in diesen Tagen meist an eine
                  Mauer des Schweigens. Der Anwalt: kein Rückruf. Der
                  Treuhänder: kein Kommentar. Der Standortförderer: weiss
                  angeblich von nichts.
                </p>
                <p>
                  Dabei gibt es einiges zu erzählen über die Beziehung zwischen
                  den beiden Ländern: Seit 2014 befindet sich die Schweiz
                  ununterbrochen unter den zehn grössten Direktinvestoren in
                  Russland. Gleichzeitig fliesst viel russisches Geld in die
                  Schweizer Wirtschaft. Viele Milliarden Franken von russischen
                  Privatpersonen und Unternehmen liegen auf Schweizer Konten.
                </p>
                <p>
                  Russen bringen aber nicht nur ihr Geld und kaufen Immobilien;
                  sie schicken auch ihre Kinder in Schweizer Internate und
                  lassen sich in Schweizer Spitälern operieren; sie handeln in
                  Lugano, Zug oder Genf mit Gas und Öl; wohnen an bester Lage in
                  den Bergen oder an Seen. Laut dem Staatssekretariat für
                  Migration (SEM) leben gerade mal 15’412 Russinnen und Russen
                  in der Schweiz. Doch die wenigen reichen Russen prägen unser
                  Land mit. Auch jene, die auf der Sanktionsliste sind.
                </p>
              </div>
            </div>
          </div>

          <div className='ui vertical segment chapters'>
            <div className='ui container'>
              <div className='ui link cards'>
                {chapters.map((ch, index) => (
                  <div
                    className='card'
                    key={ch.card.title}
                    id={ch.card.title}
                    onClick={e => {
                      this.handleClick(e, { index })
                    }}
                  >
                    <div className='image'>{ch.card.Image}</div>
                    <div className='content'>
                      <div className='overline'>{ch.card.chapter}</div>
                      <div className='header'>{ch.card.title}</div>
                      <div className='meta' />
                      <div className='description'>{ch.card.lead}</div>
                    </div>
                    <div className='extra content'>
                      Mehr erfahren{' '}
                      <i className='icon long arrow alternate right' />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <Footer
            articleId={ARTICLE_ID}
            hidePortfolioTeaser
            inverted
            questions={[
              'Wie informativ war der Beitrag?',
              'Wie gut funktionierte die technische Umsetzung?',
              'Wie gefällt Ihnen die Gestaltung?'
            ]}
            credits={[
              ['Konzept', 'Yann Cherix und Christian Zürcher'],
              [
                'Texte',
                'Sylvain Besson, Christian Brönnimann, Jorgos Brouzos, Markus Häfliger, Ewa Hess, Thomas Knellwolf, Barbara Reye, Quentin Schlapbach, Oliver Zihlmann'
              ],
              ['Illustrationen', 'Christina Baeriswyl'],
              ['Bildredaktion', 'Olaf Hille'],
              ['Digitale Umsetzung', 'Patrick Vögeli']
            ]}
          />
        </div>
      </>
    )
  }
}
